import { createTransform } from 'redux-persist';

function pickWhatToStore(inboundState, key) {
  const { isAuthenticated } = inboundState.auth ? inboundState.auth : {};
  switch (key) {
    case 'areas':
      return {
        dailyPlanning: {
          filters: inboundState.dailyPlanning.filters,
          selectedDate: inboundState.dailyPlanning.selectedDate,
          treatmentInstanceSorting: inboundState.dailyPlanning.treatmentInstanceSorting,
        },
      };
    case 'global':
      return {
        auth: { isAuthenticated },
      };
    default:
      return undefined;
  }
}

const persistTransform = createTransform((inboundState, key) => pickWhatToStore(inboundState, key));

export default persistTransform;
